/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Group_AddInputs */

const en_editor_group_add = /** @type {(inputs: Editor_Group_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const de_editor_group_add = /** @type {(inputs: Editor_Group_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {Editor_Group_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_group_add = /** @type {((inputs?: Editor_Group_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Group_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_group_add(inputs)
	return en_editor_group_add(inputs)
});